// extracted by mini-css-extract-plugin
export default {"container":"Applicant_container__zR+WP","page":"Applicant_page__p4gMR","section":"Applicant_section__47MnT"};